import React, { FC, useMemo } from "react"
import { IconButton, IconButtonProps, useTheme } from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { getIcon } from "utils/icon"
import { useAppUI } from "providers/ui"

export const HeaderBackButton: FC<IconButtonProps> = ({
  size = "large",
  ...props
}) => {
  const theme = useTheme()
  const { goBack } = useAppUI()
  const styleOverrides =
    theme.components[`AppHeaderBackButton`]?.styleOverrides || {}
  const { root, icon } = styleOverrides

  const backIcon = useMemo(
    () => getIcon(theme?.assets?.backIcon, icon) || <ArrowBackIcon />,
    [theme, icon]
  )
  return (
    <IconButton
      edge="start"
      color="inherit"
      aria-label="back"
      sx={root}
      onClick={goBack}
      {...props}
    >
      {backIcon}
    </IconButton>
  )
}
